<template>
  <div class="left cadfm-flexitem-fixed" v-if="partId">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="toggleLeftPanel" icon="hide" bold text="Hide" tooltip="Hide panel" :disabled="false" />



        </b-navbar-nav>
      </action-bar>
      <action-content>
        <div class="Tabs">
          <b-tabs card>

            <b-tab :title="lang.Content.tab_Revisions" :title-link-class="textColors" :title-item-class="textColors"
              active>
              <!-- <p>{{lang.Content.infotext_1}}: {{selectedLibrary}}<br>
              {{ lang.Content.infotext_2 }}: {{ libraryCategory }}</p> -->
              <InfoElementComponent :lang="lang.Content.InfoElement"></InfoElementComponent>
              <RevisionTableComponent :lang="lang.Content.RevisionsTable"></RevisionTableComponent>
            </b-tab>


          </b-tabs>

        </div>
      </action-content>
    </action-panel>

  </div>
</template>


<script>

//import Right from '@/components/PartManager/Right/Right'
//import { mapGetters } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import RevisionTableComponent from '@/components/shared/RevisionTableComponent'
import InfoElementComponent from '@/components/shared/InfoElementComponent'
//import RevisionDiagramComponent from '@/components/shared/RevisionDiagramComponent'

export default {
  name: 'Left',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,

    RevisionTableComponent,
    InfoElementComponent,
    //RevisionDiagramComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      name: "LeftContentLibraryDetails",
      partId: true,
      // detailsButtonStatus: false,
      // libraryCategory: "",
      // ln: ""
    }
  },
  computed: {
    // ...mapGetters({

    //   revisionHistory: 'revisionHistory',
    //   selectedRows: 'selectedRows'
    // }),
    // selectedLibrary(){
    //   let ln = this.ln;  
    //   // for (let prop in this.$store.getters.selectedRows[0]){
        
    //   //   if (this.$store.getters.selectedRows[0][prop].type == "library number"){
    //   //     ln = this.$store.getters.selectedRows[0][prop].value.display;
    //   //     break;
    //   //   }
    //   // }    

    //   return ln;
    // },
    // isData(){
    //   return Object.keys(this.$store.getters.revisionHistory).length != 0
    //   //return this.$store.getters.revisionHistory.length != 0
    // },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    
  },

  created() {

    

  },
  watch: {
    
  },
  updated() {
        

  },
  methods: {
    
    toggleLeftPanel(){

      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;

    }
  }
}
</script>


<style scoped>
.left{
  border-right: 1px solid #666;
  min-width: 400px;
  max-width: 500px;
  word-wrap: break-word;
}

.center-content{
  text-align: center;
}
img {
  max-width:200px;
  max-height:200px;
}
</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryDetails/Left/Left.vue